import * as React from 'react'
import { IconButton } from '@mui/material'
import ArrowRightIcon from '@mui/icons-material/ArrowRightOutlined'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeftRounded'
import { useRef } from 'react'

export default function HorizontalScrollWrapperComponent(props: {
  children: React.ReactNode
  buttonStyle?: any
}) {
  const contentRef = useRef(null)

  const scrollLeft = () => {
    if (contentRef.current) {
      ;(contentRef.current as any).scrollLeft -= 300
    }
  }

  const scrollRight = () => {
    if (contentRef.current) {
      ;(contentRef.current as any).scrollLeft += 300
    }
  }

  return (
    <div style={{ position: 'relative' }}>
      <div
        ref={contentRef}
        className={'my-horizontal-scroll-wrapper-element'}
        style={{
          overflowX: 'auto',
          width: '100%',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <div>{props.children}</div>
      </div>
      <IconButton
        onClick={scrollLeft}
        className={'my-scroll-button'}
        style={{
          left: '2px',
          color: '#fafafaab',
          ...props.buttonStyle,
        }}
        size="large"
      >
        <ArrowLeftIcon />
      </IconButton>
      <IconButton
        onClick={scrollRight}
        className={'my-scroll-button'}
        style={{
          right: '2px',
          color: '#fafafaab',
          ...props.buttonStyle,
        }}
        size="large"
      >
        <ArrowRightIcon />
      </IconButton>
      <style>
        {`
        /* Hide scrollbar for Chrome, Safari and Opera */
.my-horizontal-scroll-wrapper-element::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.my-horizontal-scroll-wrapper-element {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.my-scroll-button {
          position: absolute;
          margin-top: -200px;
          background-color: transparent;
          border: 1px solid #efebeb;
          box-shadow: 0px 0px 0px 0px rgb(199 193 193 / 20%), 0px 4px 5px 0px rgb(179 170 170 / 14%), 0px 1px 10px 0px rgb(224 216 216 / 12%);

}

        `}
      </style>
    </div>
  )
}
